import { Card } from "./Card";
import type { CardType } from "../game/useMemoryGame";
import "./GameBoard.css";

type Props = {
  cards: CardType[];
  first: number | null;
  second: number | null;
  onCardClick: (index: number) => void;
};

export function GameBoard({ cards, first, second, onCardClick }: Props) {
  return (
    <div className="board-grid">
      {cards.map((card, index) => (
        <Card
          key={card.id}
          card={card}
          isFlipped={index === first || index === second || card.matched}
          onClick={() => onCardClick(index)}
        />
      ))}
    </div>
  );
}